import { defineStore } from "pinia";

export const useRecipeStore = defineStore("recipeStore", () => {
 
    async function getRecipePaginate(filter) {
        try {
          const data = await useNuxtApp().$apiAuth(`/api/recipe/paginate`,{
            method: 'GET',
            use: 'admin',
            params:{
              ...filter
            }
           })
      
            return {
              success: true,
              data: data?.data,
            };
       
        } catch (error) {

          return {
            success: false,
            status: error.response?.status,
            data: null,
          };
        }
      }
      async function getRecipes() {
        try {
          const data = await useNuxtApp().$apiAuth(`/api/recipe/get/all`,{
            method: 'GET',
             use: 'admin'
           })

            return {
              success: true,
              data: data?.data,
            };
  
        } catch (error) {
 
          return {
            success: false,
            status: error.response?.status,
            data: null,
          };
        }
      }
      async function recipeCreate(category) {
        try {
           const data = await useNuxtApp().$apiAuth(`/api/recipe/create`,{
               method: 'POST',
                use: 'admin',
               body:{
                 ...category
               }
     })
            return {
              success: data?.success,
              data: data?.data,
              errorValidation: {}
            };
         
        } catch (error) {

          return {
            success: false,
            status: error.response?.status,
            data: null,
            errorValidation: error?.response?._data?.errors
          };
        }
      }
      async function recipeUpdate(category) {
        try {
          const data = await useNuxtApp().$apiAuth(`/api/recipe/update`,{
            method: 'PUT',
             use: 'admin',
            body:{
              ...category
            }
           })
            return {
              success: data?.success,
              data: data?.data,
              errorValidation: {}
            };
         
        } catch (error) {
 
          return {
            success: false,
            status: error.response?.status,
            data: null,
            errorValidation: error?.response?._data?.errors
          };
        }
      }
      async function recipeDelete(id) {
        try {
          const data = await useNuxtApp().$apiAuth(`/api/recipe/delete/${id}`,{
            method: 'DELETE',   
             use: 'admin'   
          })
       
            return {
              success: data?.success,
              data: data?.data,
              errorValidation: {}
            };
        
        } catch (error) {
 
          return {
            success: false,
            status: error.response?.status,
            data: null,
            errorValidation: error?.response?._data?.errors
          };
        }
      }
      async function recipeCacheSet() {
        try {
          const data = await useNuxtApp().$apiAuth(`/api/recipe/cache/set`,{
            method: 'GET'
           })
 
            return {
              success: data?.success,
              data: data?.data,
            };
  
        } catch (error) {
 
          return {
            success: false,
            status: error.response?.status,
            data: null,
          };
        }
      }
       async function recipeCacheGet() {
        try {
          const data = await useNuxtApp().$apiAuth(`/api/recipe/cache/get`,{
            method: 'GET'
           })
 
            return {
              success: data?.success,
              data: data?.data,
            };
  
        } catch (error) {
 
          return {
            success: false,
            status: error.response?.status,
            data: null,
          };
        }
      }
       async function getRecipeListing(filter) {
        try {
          const { data } = await useNuxtApp().$apiAxios.get(`/api/recipe/listing`,{

            params:{
              ...filter
            }
           })
      
            return {
              success: true,
              data: data?.data,
            };
       
        } catch (error) {

          return {
            success: false,
            status: error.response?.status,
            data: null,
          };
        }
      }
      async function getRecipeListingDetails(filter) {
        try {
          const { data } = await useNuxtApp().$apiAxios.get(`/api/recipe/listing/details`,{
            params:{
              ...filter
            }
           })
      
            return {
              success: true,
              data: data?.data,
            };
       
        } catch (error) {

          return {
            success: false,
            status: error.response?.status,
            data: null,
          };
        }
      }
return {
    getRecipes,
    getRecipePaginate,
    recipeCreate,
    recipeUpdate,
    recipeDelete,
    recipeCacheSet,
    recipeCacheGet,
    getRecipeListing,
    getRecipeListingDetails
    
}


})
